import {
  eMucThuSinhVienPhan,
  IMucThuSinhVienTab,
} from "../../../model/request/muc-thu/IMucThuSinhVienTab";
import { IMucThuKhacSinhVienSaveRequest } from "../../../model/request/chung-tu/IMucThuKhacSinhVienSaveRequest";
import { IMucThuKhacSinhVienSelectRequest } from "../../../model/request/chung-tu/IMucThuKhacSinhVienSelectRequest";
import { IMucThuKhacSinhVienUpdateSoTienRequest } from "../../../model/request/chung-tu/IMucThuKhacSinhVienUpdateSoTienRequest";
import { IStuHoSoSinhVienViewModel } from "../../../model/respone/category/IStuHoSoSinhVienViewModel";
import { IMucThuKhacSinhVienViewModel } from "../../../model/respone/chung-tu/IMucThuKhacSinhVienViewModel";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

/** Dữ liệu gắn với MỘT tab sinh viên (id = id tab). */
export interface IMucThuSinhVienTabType<T> {
  id: string;
  data: T;
}

/** Yêu cầu nạp lại khoản thu khác của một tab. */
export interface IMucThuSinhVienLoadType {
  id: string;
  request: IMucThuKhacSinhVienSelectRequest;
}

/** Thao tác ghi (duyệt / hủy duyệt / gỡ bỏ) trên các khoản đã chọn của một tab. */
export interface IMucThuSinhVienIdsType {
  id: string;
  ids: number[];
  request: IMucThuKhacSinhVienSelectRequest;
}

export const eMucThuSinhVienActionsObj = {
  ADD_NEW_TAB: {} as undefined | IStuHoSoSinhVienViewModel,
  REMOVE_TAB: "",
  CHANGE_SELECTED_TAB: "",
  /** Chọn sinh viên cho một tab trống (hoặc đổi sang em khác trong chính tab đó). */
  CHON_SINH_VIEN: {} as IMucThuSinhVienTabType<IStuHoSoSinhVienViewModel>,
  UPDATE_TAB_DATA: {} as IMucThuSinhVienTab,
  CHANGE_PHAN: {} as IMucThuSinhVienTabType<eMucThuSinhVienPhan>,
  CHANGE_XEM_TAT_CA_KY: {} as IMucThuSinhVienTabType<boolean>,
  CHANGE_SELECTED_IDS: {} as IMucThuSinhVienTabType<number[]>,

  LOAD_KHOAN_THU_START: {} as IMucThuSinhVienLoadType,
  LOAD_KHOAN_THU_SUCCESS: {} as IMucThuSinhVienTabType<
    IMucThuKhacSinhVienViewModel[]
  >,
  LOAD_KHOAN_THU_ERROR: {} as IMucThuSinhVienTabType<string>,

  /** Thêm MỘT HOẶC NHIỀU khoản cho sinh viên trong một lần bấm. */
  THEM_KHOAN_START: {} as {
    id: string;
    payloads: IMucThuKhacSinhVienSaveRequest[];
    request: IMucThuKhacSinhVienSelectRequest;
    /** true = thêm xong DUYỆT THU luôn các khoản vừa thêm (đỡ phải tích chọn rồi bấm duyệt). */
    duyet_luon?: boolean;
  },
  SUA_SO_TIEN_START: {} as {
    id: string;
    payload: IMucThuKhacSinhVienUpdateSoTienRequest;
    request: IMucThuKhacSinhVienSelectRequest;
  },
  XOA_KHOAN_START: {} as IMucThuSinhVienIdsType,
  DUYET_THU_START: {} as IMucThuSinhVienIdsType,
  HUY_DUYET_THU_START: {} as IMucThuSinhVienIdsType,
  /** Hủy duyệt xong gỡ luôn khỏi sinh viên — khoản đã duyệt không gỡ thẳng được. */
  HUY_DUYET_VA_GO_START: {} as IMucThuSinhVienIdsType,
  /** Bật/tắt cờ đang xử lý của tab (nút quay vòng, khóa thao tác). */
  CHANGE_DANG_XU_LY: {} as IMucThuSinhVienTabType<boolean>,

  OPEN_PROCESSING_MODAL: "",
  CLOSE_PROCESSING_MODAL: undefined,
};

export const eMucThuSinhVienActionIds = generateActionTypeIds(
  eMucThuSinhVienActionsObj,
  "MUC_THU_SINH_VIEN",
);

export type IMucThuSinhVienActionTypes = IGenericActionType<
  typeof eMucThuSinhVienActionsObj,
  "MUC_THU_SINH_VIEN"
>;
